import { makeStyles } from "@material-ui/core"

export const useStyles = makeStyles(theme => ({
  enableMercadoPagoIntegrationContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  pagseguroOrders: {
    "&__enablePaymentOption": {
      marginTop: "10px",
      paddingBottom: "10px",
      "& div": {
        display: "flex",
        justifyContent: "space-between"
      }
    }
  },
  partnerContainer: {
    display: "flex",
    alignItems: "center"
  },
  buttonSave: {
    color: "#fff",
    minWidth: "100%",
    height: "50px",
    boxShadow:
      "0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)",
    marginTop: "5px",
    marginBottom: "15px",
    textTransform: "none",
    backgroundColor: "#EA3458",

    "&:hover": {
      boxShadow: "none !important",
      backgroundColor: "#EA3458 !important"
    }
  },
  paymentOptionsContainer: {
    display: "flex",
    flexDirection: "column"
  },
  creditCardPaymentOptionContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem"
  },
  paymentOptionSwitchContainer: {
    display: "flex",
    flexDirection: "column",
    paddingTop: "10px",
    "& p": {
      margin: 0
    }
  },

  switchLabelContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    justifyContent: "space-between"
  },

  paymentOptionsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "15px"
  },
  paymentOptionSwitchLabel: {
    color: "#EA3458",
    fontSize: "20px",
    fontWeight: "500"
  },
  paymentMethodContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem"
  },
  paymentOptionSwitchLabelContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem"
  },

  taxesAndTariffsContainer: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    "& h3": {
      margin: 0,
      fontSize: "20px",
      fontWeight: "500"
    },
    "& p": {
      margin: 0,
      fontSize: "14px",
      fontWeight: "300",
      color: "#6C6C6C",
      marginBottom: "10px"
    }
  },

  taxesAndTariffsContainerInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "0.5rem"
  },

  statusContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  statusRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    justifyContent: "space-between"
  },
  statusIndicator: {
    width: "16px",
    height: "16px",
    backgroundColor: "#ff0000",
    borderRadius: "50%",
    flexShrink: 0
  },
  statusText: {
    margin: "0px",
    color: "#000000"
  },
  refreshButton: {
    border: "solid 1px #ff0063",
    backgroundColor: "transparent",
    cursor: "pointer",
    padding: "5px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "5px",
    "&:hover": {
      backgroundColor: "rgba(255, 0, 99, 0.1)"
    }
  },
  refreshIcon: {
    color: "#FF0063",
    width: "20px",
    height: "20px"
  },
  errorText: {
    margin: "0px",
    color: "#FF0000"
  },
  helpLink: {
    marginTop: "10px",
    fontSize: "14px",
    fontWeight: "400",
    color: "#0066FF",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  }
}))
